import { CourseThemeDataFull } from './types';

/**
 * action types
 */
export const UPDATE_COURSES = 'UPDATE_COURSES';
export const FETCH_COURSE_OUTCOMES = 'FETCH_COURSE_OUTCOMES';
export const RETRIEVE_COURSE_OUTCOMES = 'RETRIEVE_COURSE_OUTCOMES';
export const START_SET_COURSE_OBJECTIVE_AND_OUTCOMES =
  'START_SET_COURSE_OBJECTIVE_AND_OUTCOMES';
export const FINISH_SET_COURSE_OBJECTIVE_AND_OUTCOMES =
  'FINISH_SET_COURSE_OBJECTIVE_AND_OUTCOMES';
export const SET_COURSE_MODULES = 'SET_COURSE_MODULES';
export const CREATE_MODULE_TO_COURSE_MODULE_SET =
  'CREATE_MODULE_TO_COURSE_MODULE_SET';
export const DELETE_MODULE_FROM_COURSE = 'DELETE_MODULE_FROM_COURSE';
export const UPDATE_MODULE_DATA = 'UPDATE_MODULE_DATA';
export const COURSE_ADD_ADMIN = 'COURSE_ADD_ADMIN';
export const SET_COURSE_LANDING_PAGE_DATA = 'SET_COURSE_LANDING_PAGE_DATA';
export const UPDATE_COURSE_THEME_DATA = 'UPDATE_COURSE_THEME_DATA';

export const UPDATE_COURSE_LANGUAGE_START = 'UPDATE_COURSE_LANGUAGE_START';
export const UPDATE_COURSE_LANGUAGE = 'UPDATE_COURSE_LANGUAGE';
export const UPDATE_COURSE_LANGUAGE_FAILED = 'UPDATE_COURSE_LANGUAGE_FAILED';

export const CREATE_COURSE_START = 'CREATE_COURSE_START';
export const CREATE_COURSE_SUCCESS = 'CREATE_COURSE_SUCCESS';
export const CREATE_COURSE_FAILURE = 'CREATE_COURSE_FAILURE';

export const FETCH_COURSE_MODULES_START = 'FETCH_COURSE_MODULES_START';
export const FETCH_COURSE_MODULES_SUCCESS = 'FETCH_COURSE_MODULES_SUCCESS';
export const FETCH_COURSE_MODULES_FAILURE = 'FETCH_COURSE_MODULES_FAILURE';

export const FETCH_COURSE_SUBSCRIPTION_DATA_START =
  'FETCH_COURSE_SUBSCRIPTION_DATA_START';
export const FETCH_COURSE_SUBSCRIPTION_DATA_SUCCESS =
  'FETCH_COURSE_SUBSCRIPTION_DATA_SUCCESS';
export const FETCH_COURSE_SUBSCRIPTION_DATA_FAILURE =
  'FETCH_COURSE_SUBSCRIPTION_DATA_FAILURE';

export const COURSE_ACCESS_DENIED = 'COURSE_ACCESS_DENIED';

export const CURRENT_COURSE_DOM_BLOB_LOADED = 'CURRENT_COURSE_DOM_BLOB_LOADED';

export const UPDATE_COURSE_SECTOR_TYPES_START =
  'UPDATE_COURSE_SECTOR_TYPES_START';
export const UPDATE_COURSE_SECTOR_TYPES = 'UPDATE_COURSE_SECTOR_TYPES';
export const UPDATE_COURSE_SECTOR_TYPES_FAILED =
  'UPDATE_COURSE_SECTOR_TYPES_FAILED';

export const FETCH_ENROLLED_CLASS_DATA_START =
  'FETCH_ENROLLED_CLASS_DATA_START';
export const FETCH_ENROLLED_CLASS_DATA_SUCCESS =
  'FETCH_ENROLLED_CLASS_DATA_SUCCESS';
export const FETCH_ENROLLED_CLASS_DATA_FAILURE =
  'FETCH_ENROLLED_CLASS_DATA_FAILURE';

export const SET_IDENTITY_SESSION_SETTINGS_START =
  'SET_IDENTITY_SESSION_SETTINGS_START';
export const SET_IDENTITY_SESSION_SETTINGS_SUCCESS =
  'SET_IDENTITY_SESSION_SETTINGS_SUCCESS';
export const SET_IDENTITY_SESSION_SETTINGS_FAILED =
  'SET_IDENTITY_SESSION_SETTINGS_FAILED';

export const SET_COURSE_COHORTS_LOCAL_PRICING =
  'SET_COURSE_COHORTS_LOCAL_PRICING';

export type CreateCourseFailureAction = {
  type: 'CREATE_COURSE_FAILURE';
  error: string;
};

export type CourseAccessDeniedAction = {
  type: 'COURSE_ACCESS_DENIED';
  subscriptionId: string;
  isLegacyEducator: boolean;
};

export interface CourseUpdateThemeDataAction {
  type: 'UPDATE_COURSE_THEME_DATA';
  coursePath: string;
  themeData: CourseThemeDataFull;
}

export interface CourseUpdateLanguageStartAction {
  type: 'UPDATE_COURSE_LANGUAGE_START';
  coursePath: string;
}

export interface CourseUpdateLanguageAction {
  type: 'UPDATE_COURSE_LANGUAGE';
  coursePath: string;
  language: string;
}

export interface CourseUpdateLanguageFailedAction {
  type: 'UPDATE_COURSE_LANGUAGE_FAILED';
  error: string;
}

export interface CourseUpdateSectorTypesStartAction {
  type: 'UPDATE_COURSE_SECTOR_TYPES_START';
  coursePath: string;
}

export interface CourseUpdateSectorTypesAction {
  type: 'UPDATE_COURSE_SECTOR_TYPES';
  coursePath: string;
  courseSectorTypes: string[];
}

export interface CourseUpdateSectorTypesFailedAction {
  type: 'UPDATE_COURSE_SECTOR_TYPES_FAILED';
  error: string;
}

export type CoursesAction =
  | CourseUpdateThemeDataAction
  | CourseUpdateLanguageStartAction
  | CourseUpdateLanguageAction
  | CourseUpdateLanguageFailedAction
  | CourseUpdateSectorTypesStartAction
  | CourseUpdateSectorTypesAction
  | CourseUpdateSectorTypesFailedAction;
